module.exports = __webpack_public_path__ + "static/media/TDSAT_Logo.9d344638.svg";